<template>
  <b-row>
    <b-col md="12">
        <b-alert v-for="(errors, id) in response.errors" :key="id" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
            <p v-if="response.errors" style="font-size:13px;margin-bottom: 0;"><b>{{ id }}</b> : <span v-for="(error, index) in errors" :key="index"><br>{{ error }}</span></p>
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-alert v-if="!response.errors" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-card>
          <div slot="header">
            Création des <strong>grilles tarifaires</strong>  
          </div>
          <b-row class="form-group">
            <b-col md="6">
              <label for="libelle">Libelle</label>
              <b-form-input type="text" v-model="grilletarifaire.libelle" placeholder="Libelle de la grille tarifaire"></b-form-input>
            </b-col>
          </b-row>
          <div slot="footer">
            <span v-if="can('grilletarifaire-create')"><b-button type="submit" size="sm" variant="primary" @click.prevent="post()"><i class="fa fa-dot-circle-o"></i> Valider</b-button></span>
            <b-button type="reset"  @click="goBack" size="sm" variant="danger"><i class="fa fa-ban"></i> Annuler </b-button>
          </div>
        </b-card>    
    </b-col>
  </b-row>
</template>

<script>

export default {
  name: 'tables',
  data(){
    return {
      dismissSecs: 10,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      response:{},
      grilletarifaire:{
            libelle: ''
      }
    }
  },
  methods:{
    goBack() {
      this.$router.go(-1)
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    },
    async post(){     
        
        this.response = await this.$store.dispatch('grilletarifaire/post_grilletarifaires',this.grilletarifaire)
        this.showAlert()
        this.reset()
         if (this.response.success) {
          console.log("mm ",this.response)
          this.$router.push({ path: `/tarifications/grilletarifaire/create/${this.response.data.libelle}` }) // -> /user/123
        }
    },
    reset(){
      this.grilletarifaire.libelle= ''
    },
    can(perm){
        return store.getters['auth/can'](perm)
    }
  },
  mounted(){
   // this.get_all_grilletarifaires()
  }
}
</script>
